<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Professionally trained as an actress, MJ Fuller has always been interested in creative writing. Often, she found herself writing poetry as a way of expressing herself, which was always well received by her peers. Eventually, she decided to take the plunge and put together a manuscript of her work. <em>Sad, Sardonic and Hopeful</em> is her first contribution to the literary world.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?379cae04